"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function PhoneThin12Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, fill: "none", viewBox: "0 0 12 12" }, props),
        react_1.default.createElement("path", { fill: "#fff", d: "M1.741.874A1.5 1.5 0 0 1 3.636.683l1.437.957c.656.457.807 1.348.34 1.988l-.82 1.286a.2.2 0 0 0 .01.227 9.216 9.216 0 0 0 1.793 1.797.198.198 0 0 0 .244-.003l.997-.801a1.48 1.48 0 0 1 2.197.153l1.289 1.678a1.5 1.5 0 0 1-.23 2.065L9.012 11.6a1.391 1.391 0 0 1-1.057.327c-2.69-.333-4.566-1.674-5.914-3.186C.731 7.27.113 5.356.015 3.244a1.414 1.414 0 0 1 .421-1.057L1.741.874Zm-.225 2.354c.095 1.845.631 3.378 1.644 4.514 1.16 1.3 2.706 2.394 4.913 2.685l1.86-1.55-1.269-1.651-.031.032-.058.046-.996.8c-.597.48-1.46.508-2.09.029a10.715 10.715 0 0 1-2.076-2.08 1.698 1.698 0 0 1-.085-1.944l.817-1.286-1.34-.891-1.29 1.296Z" }));
}
function PhoneThin12(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(PhoneThin12Svg, Object.assign({}, svgProps)));
}
exports.default = PhoneThin12;
//# sourceMappingURL=PhoneThin12.js.map